import * as React from "react";
import Select from "react-select";
import { useAddServiceModal } from "./useAddServiceModal";
import { durationList } from "app/redux/businessServicesSlice";
import { find } from "lodash";
import {
  AsInput,
  AsButton,
  AsIconButton,
  DialogLayout,
  reactSelectStyles,
} from "app/subframe";

export interface AddServiceModalProps {
  showAddServiceModal: boolean;
  setShowAddServiceModal: (show: boolean) => void;
  serviceCategoryIdForNewService?: number;
}

export const AddServiceModal: React.FC<AddServiceModalProps> = ({
  showAddServiceModal,
  setShowAddServiceModal,
  serviceCategoryIdForNewService,
}) => {
  const { onFormChange, isValid, onSubmit, duration, setDuration, isCreating } =
    useAddServiceModal({
      setShowAddServiceModal,
      serviceCategoryIdForNewService,
    });

  return (
    <DialogLayout
      open={showAddServiceModal}
      onOpenChange={setShowAddServiceModal}
      className="rounded px-8 py-12 z-[1000]"
    >
      <div className="flex relative flex-col h-auto w-112 py-4 mobile:w-full items-center px-8">
        <AsIconButton
          name="FeatherX"
          variant="ghost"
          size="xs"
          className="absolute top-4 right-4"
          onClick={() => setShowAddServiceModal(false)}
        />

        <h2 className="text-xl w-full font-semibold mb-8">
          Create new service
        </h2>

        <form
          className="flex flex-col w-full gap-6"
          onChange={(e) => onFormChange(e)}
          onSubmit={onSubmit}
        >
          <AsInput
            label="Service name"
            name="title"
            placeholder="Enter service name"
            textPosition="left"
            required
          />

          <div className="flex flex-col gap-4">
            <div className="flex w-full justify-between items-center">
              <p className="text-zinc-500 text-sm">Duration</p>
              <Select
                className="w-full max-w-[120px]"
                value={{
                  value: duration?.duration,
                  label: duration?.label,
                }}
                onChange={(newValue: any) => {
                  setDuration({
                    duration: newValue.value,
                    label:
                      find(durationList, {
                        duration: newValue.value,
                      })?.label || "",
                  });
                }}
                options={durationList.map(({ duration, label }) => ({
                  value: duration,
                  label: label,
                }))}
                styles={reactSelectStyles({
                  borderContainer: true,
                })}
              />
            </div>

            <div className="flex w-full justify-between items-center">
              <p className="text-zinc-500 text-sm">Price</p>
              <AsInput
                type="number"
                name="price"
                leading="$"
                className="w-full max-w-[120px]"
                textPosition="left"
              />
            </div>
          </div>

          <AsInput
            label="Notes"
            name="notes"
            placeholder="Enter notes"
            textPosition="left"
          />

          <AsButton
            type="submit"
            className="w-full mt-4"
            disabled={!isValid}
            text="Create"
            loader={isCreating}
          />
        </form>
      </div>
    </DialogLayout>
  );
};
